// @ts-nocheck
const VIEWPORT_CONFIGS = [
  {
    wrapper: '.fwrd-hiw__wrapper',
    video: '.fwrd-hiw__video-container video',
    cover: '.fwrd-hiw__cover-image-wrapper',
    button: '[data-video-button]',
    pauseIcon: '.fwrd-hiw__icon-pause',
    extraHideOnPlay: '.fwrd-hiw__video-text',
  },
  {
    wrapper: '.fwrd-what-and-how__wrapper',
    video: '.fwrd-what-and-how__media--video video',
    cover: '.fwrd-what-and-how__cover-image-wrapper',
    button: '[data-video-button]',
    pauseIcon: '.fwrd-what-and-how__icon-pause',
  },
];

function setPlayingState(wrapper, config, isPlaying) {
  const cover = wrapper.querySelector(config.cover);
  const button = wrapper.querySelector(config.button);
  const playIcon = button?.querySelector('svg');
  const pauseIcon = button?.querySelector(config.pauseIcon);
  const extra = config.extraHideOnPlay
    ? wrapper.querySelector(config.extraHideOnPlay)
    : null;

  if (cover) cover.style.display = isPlaying ? 'none' : 'block';
  if (extra) extra.style.display = isPlaying ? 'none' : 'block';
  if (playIcon) playIcon.style.display = isPlaying ? 'none' : 'block';
  if (pauseIcon) pauseIcon.style.display = isPlaying ? 'flex' : 'none';
  if (button) {
    button.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video');
  }
}

async function playVideo(wrapper, config) {
  const video = wrapper.querySelector(config.video);
  if (!video) return;

  video.muted = true;

  try {
    await video.play();
    setPlayingState(wrapper, config, true);
  } catch {
    setPlayingState(wrapper, config, false);
  }
}

function pauseVideo(wrapper, config) {
  const video = wrapper.querySelector(config.video);
  if (!video) return;

  video.pause();
  setPlayingState(wrapper, config, false);
}

function initViewportAutoplay(root = document) {
  VIEWPORT_CONFIGS.forEach((config) => {
    root.querySelectorAll(config.wrapper).forEach((wrapper) => {
      if (wrapper.dataset.viewportInit) return;
      wrapper.dataset.viewportInit = 'true';

      const video = wrapper.querySelector(config.video);
      if (!video) return;

      // Shopify's video_tag renders a fallback <img> inside <video> with no alt
      // attribute and gives us no way to set one. It is decorative here, so mark
      // it as such rather than leaving the image-alt audit failing.
      video.querySelectorAll('img:not([alt])').forEach((img) => {
        img.setAttribute('alt', '');
      });

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              playVideo(wrapper, config);
            } else {
              pauseVideo(wrapper, config);
            }
          });
        },
        { threshold: 0.5 }
      );

      observer.observe(wrapper);
    });
  });
}

document.addEventListener('DOMContentLoaded', () => initViewportAutoplay());

document.addEventListener('shopify:section:load', (event) => {
  if (event.target instanceof HTMLElement) initViewportAutoplay(event.target);
});
